import Icon from 'veui/components/Icon'
import { IconListUnordered } from 'dls-icons-vue'

Icon.register('list-unordered', IconListUnordered)
